import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({
    testid,
    value,
    onChange,
    className = "",
    autoComplete = "current-password",
    minLength,
}) => {
    const [show, setShow] = useState(false);
    return (
        <div className="relative">
            <input
                data-testid={testid}
                type={show ? "text" : "password"}
                value={value}
                onChange={onChange}
                required
                autoComplete={autoComplete}
                minLength={minLength}
                className={`${className} pr-10`}
            />
            <button
                type="button"
                data-testid={`${testid}-visibility-toggle`}
                onClick={() => setShow(!show)}
                aria-label="Wachtwoord tonen of verbergen"
                className="absolute inset-y-0 right-0 flex items-center text-ash transition-colors hover:text-gold"
            >
                {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
        </div>
    );
};
